import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './home/welcome.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { Requestor, FetchRequestor } from '@openid/appauth';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { CallbackComponent       } from './callback/callback.component';
import { environment             } from '../environments/environment';


/* Feature Modules */
import { UserModule } from './users/user.module';
import { LicenseModule } from './licenses/license.module';
import { AuthorityModule } from './authorities/authority.module';
import { ResourceModule } from './resources/resource.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './users/auth.interceptor';
import { SharedModule } from './shared/shared.module';
import { NgIdleModule } from '@ng-idle/core';
//import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { AboutComponent } from './about/about.component';
import { AuthorizationService } from  './authorization.service';
//import { CurrencyMaskModule } from "ngx-currency-mask";

//import { MsalModule } from '@azure/msal-angular';


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AuthorityModule,
    UserModule,
    LicenseModule,
    ResourceModule,
    AppRoutingModule,
    SharedModule,
    NgxGoogleAnalyticsModule.forRoot('UA-112173829-1'),
    NgxGoogleAnalyticsRouterModule,
    NgIdleModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    CallbackComponent,
    WelcomeComponent,
    PageNotFoundComponent,
    AboutComponent,
//   FooterComponent, 
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthorizationService,
    { provide: 'AuthorizationConfig', useValue: environment}, 
    { provide: Requestor, useValue: new FetchRequestor()}, 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ] 
})
export class AppModule { }
